function readURL(input) {
    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
            $('#preview-image')
                .attr('src', e.target.result);
            //.width(100%)
            //.height(100%);
        };

        reader.readAsDataURL(input.files[0]);
        $(".img-upload").find('input[type="hidden"]').addClass('changed-input').val('');

        $(".img-upload").append("<span class='delete-img'></span>");
        $(".img-upload .delete-img").on("click", function () {
            $(".img-upload .delete-img").remove();
            $("#preview-image").removeAttr("src");
            $(".img-upload").find('input[type="hidden"]').addClass('changed-input').val('');
        });

    }
}

function animationOnLoad() {
    $(".wow-wrap").addClass("anim-start");
}

$(window).on('load', function () {
    setTimeout(animationOnLoad, 500);
});

$(document).ready(function () {

    // FAKER INIT
    specto_faker.init({
        object_selector: ".faker:not(#selector-category)",
        animated: true,
    });

    specto_faker.init({
        animated: true,
        object_selector: "#selector-category",
        on_change: function (newVal, jsEvent) {
            console.log('chng');
            if(typeof $('.equalize').first().attr('style') === "string"){
                $('.equalize').removeAttr('style').matchHeight('remove');
            }
            if (parseInt(newVal) === 0) {
                $('.projects-list').removeAttr('hidden', '').addClass('equalize');
            } else {
                $('.projects-list').each(function(){
                    if(this.getAttribute('data-category') == newVal) {
                        this.removeAttribute('hidden');
                        this.classList.add('equalize');
                    } else {
                        this.setAttribute('hidden', '');
                        this.classList.remove('equalize');
                    }
                });
            }
            window.location.hash = `cat=${newVal}`;

            //update equal-height
            $('.equalize').matchHeight({
                byRow: false,
                property: 'height',
                target: null,
                remove: false
            });
        },
        on_init: function(fakers){
            if(window.location.hash) {
                const cid = window.location.hash.substr(5);
                specto_faker.updateFakerValue(cid);
            }
            else $('.equalize').matchHeight({
                byRow: true,
                property: 'height',
                target: null,
                remove: false
            });
        },
    });


    if ($(".front-new-vawes").length) {
        $("body").addClass("is-homepage");
    }

    // PRIJAVA NA WEBSI DAN -> ko klikneš submit te zascrolla na vrh containerja forme

    /*$("#sub-form-websi button.btn").click(function() {

        setTimeout(function(){
            $('html, body').animate({
                scrollTop: $("#sub-form-websi").offset().top
            }, 2000);

        	}, 1000);
    });*/

    // OPEN MOBILE MENU

    $(".mobile-menu-toggle").click(function () {

        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            // $("body").removeClass("mobile-menu-active");
            $(".head-nav ul").slideUp("300");
        } else {
            $(this).addClass("active");
            // $("body").addClass("mobile-menu-active");
            $(".head-nav ul").slideDown("300");
        }
    });

    // OPEN / CLOSE ACCORDIAN

    $(".accordian-single").each(function () {
        $(this).find(".accordian-toggle").on("click", function () {

            if ($(this).parent().hasClass("accordian-open")) {
                $(this).parent().removeClass("accordian-open");
                $(this).parent().find(".accordian-content").slideUp("400");
            } else {
                $(this).parent().addClass("accordian-open");
                $(this).parent().find(".accordian-content").slideDown("400");
            }
        });
    });

    // ADD PREVIEW IMAGE AT PRIJAVA

    if (!$("#preview-image").attr("src") == "") {
        $(".img-upload").append("<span class='delete-img'></span>");
    }

    $(".img-upload .delete-img").on("click", function () {
        $("#preview-image").removeAttr("src");
        $(".img-upload .delete-img").remove();
        $(".img-upload").find('input[type="hidden"]').addClass('changed-input').val('');
    });


    $(".img-upload").on("mouseenter", function () {

        $(this).find("button").addClass("img-hover");
    });

    $(".img-upload").on("mouseleave", function () {

        $(this).find("button").removeClass("img-hover");
    });

    // hide/show some fields, depend on category
    $('#category').on('change', function () {
        let sData1 = $(this).find(":selected").data('showAdditional1');
        let sData2 = $(this).find(":selected").data('showAdditional2');
        $('#prijava-additional').css('display', 'block');

        if (sData1 == true) {
            $('#additional_display_1').show();
            $('#additional_display_2').hide();
        } else {
            $('#additional_display_2').show();
            $('#additional_display_1').hide();
        }
        // set other texts to empty strings
        /*$('#project_comment_1').val('');
          $('#project_comment_2').val('');
          $('#project_comment_3').val('');*/
    });

    $(".add-new-lines.main-stategic-goals .single-line:first-child .command-icon").on("click", function () {

        var lineValue = $(this).parent().find("input");

        $(this).parent().parent().append("<div class='single-line : added-line'><input name='" + lineValue.attr("name") + "' type='text' value='" + lineValue.val() + "'><div class='command-icon'><span></span><em class='command-desc'>Odstrani cilj</em></div></div>");
        lineValue.val('').focus();
    });

    $(".add-new-lines.main-kpi .single-line:first-child .command-icon").on("click", function () {

        var lineValue = $(this).parent().find("input");
        if ($(".add-new-lines.main-kpi .single-line.added-line .command-icon").length <= 3) // max 5 available
        {
            $(this).parent().parent().append("<div class='single-line : added-line'><input name='" + lineValue.attr("name") + "' type='text' value='" + lineValue.val() + "'><div class='command-icon'><span></span><em class='command-desc'>Odstrani glavni kpi</em></div></div>");
            lineValue.val('').focus();
        }
    });

    $(".add-new-lines.main-url-links .single-line:first-child .command-icon").on("click", function () {

        var lineValue = $(this).parent().find("input");

        $(this).parent().parent().append(
          "<div class='single-line : added-line'><input name='" + lineValue.attr("name") + "' type='text' value=''>" +
          "<div class='command-icon'><span></span><em class='command-desc'>Odstrani URL povezavo</em>" +
          "</div>" +
          "</div>");

        $(this).parent().parent().find('div.single-line').last().find('input').focus();
    });

    $(document).on("click", ".add-new-lines .single-line.added-line .command-icon", function () {

        $(this).parent().remove();

    });

    $('.form-group textarea').each(function () {

        let val = $(this).val();
        let len = val.length;

        let count = $(this).parent().find("textarea[maxlength]").attr('maxlength');
        $(this).parent().find(".signs-counter").empty().append(len + "/" + count);

        $(this).keyup(function () {
            let val = $(this).val();
            let len = val.length;

            $(this).parent().find(".signs-counter").empty().append(len + "/" + count);

            let txtArea = $(this);
            if (!$(this).hasClass('full') && parseInt(len) === parseInt(count)) {
                let html = '<h3>Obvestilo!</h3>';
                html+= '<p>Dosegli ste maksimalno število znakov.</p>';
                $('#default_project .modal-content-wrap').html(html);
                $('#default_project .button-confirm').hide();
                $('#default_project .button-cancel').text('V redu');
                $('#default_project').modal('show');

            }
            // inform user that limit is reached
            if (parseInt(len) === parseInt(count)) {
                $(this).addClass('full');
            } else {
                $(this).removeClass('full');
            }
        });
    });

    if ($('.tab-content').length == 0) {
        $("html, body").stop(true, false).animate({
            scrollTop: 0
        }, 10);

        $(window).load(function () {
            if (window.location.hash != '' && window.location.hash.substr(0,5) !== '#cat=') {
                $("html, body").stop(true, false).animate({
                    scrollTop: $(window.location.hash).offset().top
                }, 1000);
            }
        });
    }

    //Match height
    $(function () {
        $('.equal-height').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    });

    let isMobile = false; //initiate as false
// device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;

    if ($('img.lazy').length) {


        if (!isMobile) {
            if ($('img.non-lazy').length > 0) {
                $(window).resize(function () {
                    $('img.lazy').height($('img.non-lazy').height());
                    $.fn.matchHeight._update();
                });
                $('img.lazy').height($('img.non-lazy').height());
                $.fn.matchHeight._update();
            }

            // $('img.lazy').load(function () {
            // 	$.fn.matchHeight._update();
            // });
        }

        $('img.lazy').lazyload({
            skip_invisible: true,
            effect: "fadeIn",
            threshold: 500
        });
    }

    new Menu();

    new ScrollAnimations();

    if ($('.speakers-popup').length) new Speakers();

    if ($('.tab-content').length) new NavTabs();

    if ($('#countdown-timer').length) new CountDownTimer();

    if ($('#bottom-header-wrap').length) new ZirantiSlider();

    if ($('.gallery').length) {
        $(window).on("load", function () {
            new Gallery();
        });
    }

    $('#sub-form-websi input[name=type]').click(function () {

        // reset all
        $('.var').fadeOut();
        $('#sub-form-websi #form').find("input[type=text], input[type=email], input[type=file]").val('');
        $('#sub-form-websi #form').find("input[type=checkbox]:not(#checkboxIAB)").attr('checked', false);

        // show selected
        $('.var.' + $(this).val()).fadeIn();

    });


    // add for organization, agency

    $('#add-organization').on('click', function () {
        let idx = $(this).parent().closest('.organization').find('.countItems').length;
        let insertHtml = $(`<div class="inner-company" style="margin-top: 70px;">
							<div class="section-title : with-button">
                                <h3>Organizacija oz. podjetje 1/1</h3>
                                <a class="button : new-btn : remove-organization-new">Odstrani organizacijo / podjetje</a>
                            </div>
							<div class="separator"></div>
							<input class="countItems" type="hidden"/>
							<input class="form-control" type="hidden" name="organization_data[${idx}][id]" value="">
								<div class="form-group">
                                    <label for="organization_data_name">Naziv organizacije / podjetja</label>
                                    <input class="form-control" type="text" name="organization_data[${idx}][name]" id="organization_data_name" value="">
                                </div>
                                <div class="form-group">
                                    <label for="organization_data_ceo">Direktor organizacije / predsednik uprave</label>
                                    <input class="form-control" type="text" name="organization_data[${idx}][ceo]" id="organization_data_ceo" value="">
                                </div>
                                <div class="form-group">
                                    <label for="organization_data_lead">Skrbnik projekta v organizaciji</label>
                                    <input class="form-control" type="text" name="organization_data[${idx}][guardian]" id="organization_data_lead" value="">
                                </div>
                                <div class="form-group">
                                    <label for="organization_data_lead_function">Funkcija / položaj skrbnika projekta</label>
                                    <input class="form-control" type="text" name="organization_data[${idx}][guardian_function]" id="organization_data_lead_function" value="">
                                </div>
							</div>`);

        insertHtml.insertBefore($(this).parent());
        /*if (idx == 1) {
            $(this).parent().append(`<div class="command-icon" id="remove-organization">
										<span></span>
										<em class="command-desc">Odstrani zadnjo organizacijo</em>
									</div>`);
            $('#remove-organization').on('click', function () {
                removeOrganizationAgency($(this), '.organization');
            });
        }*/

        $('.remove-organization-new').on('click', function () {
            $(this).parent().closest('.inner-company').remove();
            checkOrganizationTitles();
        });

        checkOrganizationTitles();
    });

    $('#remove-organization').on('click', function () {
        removeOrganizationAgency($(this), '.organization');
    });

    $('.remove-organization-new').on('click', function () {
        $(this).parent().closest('.inner-company').remove();
        checkOrganizationTitles();
    });

    function checkOrganizationTitles() {
        const companyCnt = $('.inner-company').length;
        $('.inner-company').each(function (idx) {
            $(this).find('.section-title h3').html('Organizacija oz. podjetje ' + (idx+1) + '/' + companyCnt);
        });
    }


    $('#add-agency').on('click', function () {
        let idx = $(this).parent().closest('.agency').find('.countItems').length;
        let insertHtml = $(`<div class="inner-agency" style="margin-top: 70px;">
									<div class="section-title : with-button">
                                        <h3>Agencija</h3>
                                        <a class="button : new-btn : remove-agency-new">Odstrani agencijo</a>
                                    </div>
									<div class="separator"></div>
									<input class="countItems" type="hidden"/>
									<input type="hidden" name="agency_data[${idx}][id]" value="">
									<div class="form-group">
										<label for="agency_data_name">Agencija</label>
										<input type="text" name="agency_data[${idx}][name]" id="agency_data_name" value="" class="form-control">
									</div>
									<div class="form-group">
										<label for="agency_data_ceo">Direktor agencije</label>
										<input type="text" name="agency_data[${idx}][ceo]" id="agency_data_ceo" value="" class="form-control">
									</div>
									<div class="form-group">
										<label for="agency_data_lead">Vodja projekta v agenciji</label>
										<input type="text" name="agency_data[${idx}][lead]" id="agency_data_lead" value="" class="form-control">
									</div>
									<div class="form-group">
										<label for="agency_data_lead_function">Funkcija vodje projekta v agenciji</label>
										<input type="text" name="agency_data[${idx}][lead_function]" id="agency_data_lead_function" value="" class="form-control">
									</div>

									<h3>Kontaktni podatki agencije</h3>

									<div class="form-group">
										<label for="agency_data_email">E-mail</label>
										<input class="form-control" type="email" name="agency_data[${idx}][email]" id="agency_data_email" value="">
									</div>
									<div class="form-group">
										<label for="agency_data_phone">Telefonska številka</label>
										<input class="form-control" type="text" name="agency_data[${idx}][phone]" id="agency_data_phone" value="">
									</div>
									<div class="form-group">
										<label for="agency_data_url">Spletna stran</label>
										<input class="form-control" type="text" name="agency_data[${idx}][web]" id="agency_data_url" value="">
									</div>
									<!--
									<div class="other-agencies">
                                        <label for="agency_data_outsider">Morebitni drugi zunanji izvajalci</label>
                                        <div class="agency-outsiders">

                                            <div class="form-group : extra-agency">
                                                <div class="extra-agency__nr">
                                                    1.
                                                </div>
                                                <div class="extra-agency__info">
                                                    <input class="form-control" type="text" name="agency_data[${idx}][outsiders][]" id="agency_data_outsider" value="">
                                                </div>
                                                <div class="extra-agency__btn">
                                                    <a class="button : new-btn : blue : remove-outsider">odstrani izvajalca</a>
                                                </div>
                                            </div>
                                        </div>
                                        <p>Zaradi sestave žirije, ki ocenjuje posamezen projekt, je potrebno navesti morebitne druge zunanje izvajalce.</p>
                                        <a class="button : new-btn : add-agency-outsider" data-idx="${idx}">+ dodaj izvajalca</a>
                                    </div> -->
								</div>`);

        //insertHtml.insertBefore($(this).parent());
        insertHtml.insertAfter($(this).parent().find('.agency-list'));
        //$(this).parent().find('.agency-list').append();

        /*
        if (idx == 1) {
            $(this).parent().append(`<div class="command-icon" id="remove-agency">
										<span></span>
										<em class="command-desc">Odstrani zadnjo agencijo</em>
									</div>`);
            $('#remove-agency').on('click', function () {
                removeOrganizationAgency($(this), '.agency');
            });
        }*/

        $('.remove-agency-new').on('click', function () {
            $(this).parent().closest('.inner-agency').remove();
            checkAgenciesTitles();
        });

        // rename agencies
        checkAgenciesTitles();

        $('.add-agency-outsider').unbind('click');
        $('.add-agency-outsider').on('click', function() {
            addAgencyOutsiderClick($(this));
        });

        $('.remove-outsider').unbind('click');
        $('.remove-outsider').on('click', function() {
            removeOutsiderClick($(this));
        });
    });

  $('#add-customer').on('click', function () {
    let idx = $(this).parent().closest('.customer').find('.countItems').length;
    let insertHtml = $(`<div class="inner-customer" style="margin-top: 70px;">
									<div class="section-title : with-button">
                                        <h3>Naročnik</h3>
                                        <a class="button : new-btn : remove-customer-new">Odstrani naročnika</a>
                                    </div>
									<div class="separator"></div>
									<input class="countItems" type="hidden"/>
									<input type="hidden" name="customer_data[${idx}][id]" value="">
									<div class="form-group">
										<label>Naziv naročnika</label>
										<input type="text" name="customer_data[${idx}][name]" id="customer_data_name" value="" class="form-control">
									</div>
									<div class="form-group">
										<label>Direktor naročnika - predsednik uprave</label>
										<input type="text" name="customer_data[${idx}][ceo]" id="customer_data_ceo" value="" class="form-control">
									</div>
									<div class="form-group">
										<label>Skrbnik projekta pri naročniku</label>
										<input type="text" name="customer_data[${idx}][lead]" id="customer_data_lead" value="" class="form-control">
									</div>
									<div class="form-group">
										<label>Funkcija / položaj skrbnika projekta</label>
										<input type="text" name="customer_data[${idx}][lead_function]" id="customer_data_lead_function" value="" class="form-control">
									</div>

									<h3>Kontaktni podatki naročnika</h3>

									<div class="form-group">
										<label for="agency_data_email">E-mail</label>
										<input class="form-control" type="email" name="customer_data[${idx}][email]" id="customer_data_email" value="">
									</div>
									<div class="form-group">
										<label for="agency_data_phone">Telefonska številka</label>
										<input class="form-control" type="text" name="customer_data[${idx}][phone]" id="customer_data_phone" value="">
									</div>
									<div class="form-group">
										<label for="agency_data_url">Spletna stran</label>
										<input class="form-control" type="text" name="customer_data[${idx}][web]" id="customer_data_url" value="">
									</div>

								</div>`);

    insertHtml.insertBefore($(this).parent());
    /*
    if (idx == 1) {
        $(this).parent().append(`<div class="command-icon" id="remove-agency">
                <span></span>
                <em class="command-desc">Odstrani zadnjo agencijo</em>
              </div>`);
        $('#remove-agency').on('click', function () {
            removeOrganizationAgency($(this), '.agency');
        });
    }*/

    $('.remove-customer-new').on('click', function () {
      $(this).parent().closest('.inner-customer').remove();
      checkAgenciesTitles();
    });

    // rename agencies
    checkCustomerTitles();

    $('.add-agency-outsider').unbind('click');
    $('.add-agency-outsider').on('click', function() {
      addAgencyOutsiderClick($(this));
    });

    $('.remove-outsider').unbind('click');
    $('.remove-outsider').on('click', function() {
      removeOutsiderClick($(this));
    });
  });

    function checkAgenciesTitles() {
        const agenciesCnt = $('.inner-agency').length;
        $('.inner-agency').each(function (idx) {
            $(this).find('.section-title h3').html('Agencija ' + (idx+1) + '/' + agenciesCnt);
        });
    }

    function checkCustomerTitles() {
      const agenciesCnt = $('.inner-customer').length;
      $('.inner-customer').each(function (idx) {
        $(this).find('.section-title h3').html('Naročnik ' + (idx+1) + '/' + agenciesCnt);
      });
    }

    $('.remove-agency-new').on('click', function () {
        $(this).parent().closest('.inner-agency').remove();
        checkAgenciesTitles();
    });

    $('.remove-customer-new').on('click', function () {
      $(this).parent().closest('.inner-customer').remove();
      checkCustomerTitles();
    });

    $('#remove-agency').on('click', function () {
        removeOrganizationAgency($(this), '.agency');
    });

    // handle agency outsiders click
    $('.add-agency-outsider').on('click', function() {
        addAgencyOutsiderClick($(this));
    });

    $('.remove-outsider').on('click', function() {
        removeOutsiderClick($(this));
    });

    function addAgencyOutsiderClick(elm) {
        let idx = elm.parent().closest('.other-agencies').find('.extra-agency').length;
        let aidx = elm.data('idx');

        let insertHtml = $(`<div class="form-group : extra-agency">
                                <div class="extra-agency__nr">
                                    1.
                                </div>
                                <div class="extra-agency__info">
                                    <label>Ime in priimek</label>
                                    <input class="form-control" type="text" data-key="name" name="project_data[outsiders][${idx}][name]" id="project_data_outsider" value="">

                                    <label>Funkcija</label>
                                    <input class="form-control" type="text" data-key="function" name="project_data[outsiders][${idx}][function]" id="project_data_outsider" value="">

                                    <label>Podjetje</label>
                                    <input class="form-control" type="text" data-key="company" name="project_data[outsiders][${idx}][company]" id="project_data_outsider" value="">
                                </div>
                                <div class="extra-agency__btn">
                                    <a class="button : new-btn : blue : remove-outsider">odstrani osebo</a>
                                </div>
                            </div>`);
          /*let insertHtml = $(`<div class="form-group : extra-agency">
                                <div class="extra-agency__nr">
                                    1.
                                </div>
                                <div class="extra-agency__info">
                                    <input class="form-control" type="text" name="agency_data[${aidx}][outsiders][]" id="agency_data_outsider" value="">
                                </div>
                                <div class="extra-agency__btn">
                                    <a class="button : new-btn : blue : remove-outsider">odstrani izvajalca</a>
                                </div>
                            </div>`);*/
        elm.parent().find('.agency-outsiders').append(insertHtml);
        $('.remove-outsider').unbind('click');
        $('.remove-outsider').on('click', function() {
            removeOutsiderClick($(this));
        });
        checkOutsidersNumbers(elm.parent().find('.agency-outsiders'));
    }

    function removeOutsiderClick(elm) {
        let mainElm = elm.parent().closest('.extra-agency').parent();
        elm.parent().closest('.extra-agency').remove();
        checkOutsidersNumbers(mainElm);
        reindexOutsiders(mainElm);
    }

    function checkOutsidersNumbers(elm) {
        let extraAgencies = elm.find('.extra-agency');
        extraAgencies.each(function (idx) {
            $(this).find('.extra-agency__nr').html((idx+1) + '.');
        });
    }

    function reindexOutsiders (elm) {
        let extraAgencies = elm.find('.extra-agency');
        extraAgencies.each(function (idx) {
            $(this).find('.extra-agency__nr').html((idx + 1) + '.');
            let inputs = $(this).find('input');
            inputs.each(function () {
                let key = $(this).data('key');
                let attrName = 'project_data[outsiders]['+idx+']['+key+']';
                $(this).attr('name', attrName);
            });
        });
    }

    // smoothscroll webis-dan menu
    $('.menu-link').on('click', function (e) {
        let elm = $(this).attr('href').toString();
        if (elm.startsWith('#')) {
            e.preventDefault();
            if (elm.startsWith('#') && $(elm).length) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(elm).offset().top - 70
                }, 1000);
            }
        }
    });

    // prijava-new form tab clicked - prevent anchor in hash
    $('.tabs-list--registration a').on('click', function (e) {
        e.preventDefault();
        specto_scroll(
            $("#form").offset().top - $(".header-main").outerHeight()
        );
    });

    $('.tabs-list a').on('click', function (e) {
        e.preventDefault();
    });
});

function removeOrganizationAgency($elm, cls) {
    $elm.parent().prev().remove();
    if ($elm.parent().closest(cls).find('.countItems').length < 2)
        $elm.remove();
}

function isEmailFormat(email) {
  return email.search(/^[\w\d\._\-]+@[\w\d\-_\.]+\.[\d\w][\d\w]+$/) > -1;
}

function submitForm(event) {
    event.preventDefault();
    event.stopPropagation();

    const selectedTab = $('.tabs-list--registration a.selected').attr('id');

    $('#sub-form-websi #form input').removeClass("error");
    switch (selectedTab) {
      case 'tab-personalParticipation':
        disableSubmitButton('person', true);
        if (!$("#personalParticipation #ime").val()) {
          $("#personalParticipation #ime").addClass("error");
          disableSubmitButton('person');
        } else if (!$("#personalParticipation #priimek").val()) {
          $("#personalParticipation #priimek").addClass("error");
          disableSubmitButton('person');
        } else if (!isEmailFormat($("#personalParticipation #enaslov").val().trim())) {
          $("#personalParticipation #enaslov").addClass("error");
          disableSubmitButton('person');
        } else if (!$("#personalParticipation #naslov").val()) {
          $("#personalParticipation #naslov").addClass("error");
          disableSubmitButton('person');
        } else if (!$("#personalParticipation #kraj").val()) {
          $("#personalParticipation #kraj").addClass("error");
          disableSubmitButton('person');
        } else if (!$("#personalParticipation #postaStevilka").val()) {
          $("#personalParticipation #postaStevilka").addClass("error");
          disableSubmitButton('person');
        } else if (!$("#agree").prop("checked")) {
          $("#agree").addClass("error");
          disableSubmitButton('person');
        } else {
          $("#personalParticipation label.css-label").removeClass("error");
          $("#personalParticipation #enaslov").removeClass("error");
          $("#personalParticipation input").removeClass("error");
          //Ajax zahtevek
          sendForm('osebna');
        }
        break;
      case 'tab-employeesParticipation':
        disableSubmitButton('comp', true);
        if (!$("#employeesParticipation #company_input").val()) {
          $("#employeesParticipation #company_input").addClass("error");
          disableSubmitButton('comp');
        } else if (!$("#employeesParticipation #company_payer_input").val()) {
          $("#employeesParticipation #company_payer_input").addClass("error");
          disableSubmitButton('comp');
        } else if (!$("#employeesParticipation #number_input").val()) {
          $("#employeesParticipation #number_input").addClass("error");
          disableSubmitButton('comp');
        } else if (!isEmailFormat($("#employeesParticipation #email_input").val().trim())) {
          $("#employeesParticipation #email_input").addClass("error");
          disableSubmitButton('comp');
        } else if (!$("#employeesParticipation #address_input").val()) {
          $("#employeesParticipation #address_input").addClass("error");
          disableSubmitButton('comp');
        } else if (!$("#employeesParticipation #city_input").val()) {
          $("#employeesParticipation #city_input").addClass("error");
          disableSubmitButton('comp');
        } else if (!$("#employeesParticipation #post_input").val()) {
          $("#employeesParticipation #post_input").addClass("error");
          disableSubmitButton('comp');
        } else if (!$("#employeesParticipation #vat_input").val()) {
          $("#employeesParticipation #vat_input").addClass("error");
          disableSubmitButton('comp');
        } else if (!$("#employeesParticipation #contact_input").val()) {
          $("#employeesParticipation #contact_input").addClass("error");
          disableSubmitButton('comp');
        } else if (!isEmailFormat($("#employeesParticipation #email_input_invoice").val().trim())) {
          $("#employeesParticipation #email_input_invoice").addClass("error");
          disableSubmitButton('comp');
        } else if (!$("#em_agree").prop("checked")) {
          $(".em_agree").addClass("error");
          disableSubmitButton('comp');
        } else {
          $("#employeesParticipation label.css-label").removeClass("error");
          $("#employeesParticipation #email_input").removeClass("error");
          $("#employeesParticipation input").removeClass("error");

          //Ajax zahtevek
          sendForm('podjetje');
        }
        break;
      case 'tab-registrationFee':
        disableSubmitButton('student', true);
        if (!$("#registrationFee #s_name").val()) {
          $("#registrationFee #s_name").addClass("error");
          disableSubmitButton('student');
        } else if (!$("#registrationFee #s_surname").val()) {
          $("#registrationFee #s_surname").addClass("error");
          disableSubmitButton('student');
        } else if (!isEmailFormat($("#registrationFee #s_email").val().trim())) {
          $("#registrationFee #s_email").addClass("error");
          disableSubmitButton('student');
        } else if (!$("#registrationFee #s_address").val()) {
          $("#registrationFee #s_address").addClass("error");
          disableSubmitButton('student');
        } else if (!$("#registrationFee #s_city").val()) {
          $("#registrationFee #s_city").addClass("error");
          disableSubmitButton('student');
        } else if (!$("#registrationFee #s_post").val()) {
          $("#registrationFee #s_post").addClass("error");
          disableSubmitButton('student');
        } else if (!$("#reg_agree").prop("checked")) {
          $(".reg_agree").addClass("error");
          disableSubmitButton('student');
        } else {
          $("#registrationFee label.css-label").removeClass("error");
          $("#registrationFee #email_input").removeClass("error");
          $("#registrationFee input").removeClass("error");


          //Ajax zahtevek
          sendForm('student');

        }
        break;
      case 'tab-applicantParticipation':
        disableSubmitButton('applicant', true);
        if (!$("#applicantParticipation #applicant_input").val()) {
          $("#applicantParticipation #applicant_input").addClass("error");
          disableSubmitButton('applicant');
        } else if (!isEmailFormat($("#applicantParticipation #applicant_email_input").val())) {
          $("#applicantParticipation #applicant_email_input").addClass("error");
          disableSubmitButton('applicant');
        } else if (!$("#applicantParticipation #applicant_nr_input").val()) {
          $("#employeesParticipation #applicant_nr_input").addClass("error");
          disableSubmitButton('applicant');
        } else if (!$("#applicantParticipation #applicant_payer").val().trim()) {
          $("#applicantParticipation #applicant_payer").addClass("error");
          disableSubmitButton('applicant');
        } else if (!$("#applicantParticipation #applicant_address").val()) {
          $("#applicantParticipation #applicant_address").addClass("error");
          disableSubmitButton('applicant');
        } else if (!$("#applicantParticipation #applicant_city").val()) {
          $("#applicantParticipation #applicant_city").addClass("error");
          disableSubmitButton('applicant');
        } else if (!$("#applicantParticipation #applicant_post").val()) {
          $("#applicantParticipation #applicant_post").addClass("error");
          disableSubmitButton('applicant');
        } else if (!$("#applicantParticipation #applicant_vat").val()) {
          $("#applicantParticipation #applicant_vat").addClass("error");
          disableSubmitButton('applicant');
        } else if (!$("#applicantParticipation #applicant_contact").val()) {
          $("#applicantParticipation #applicant_contact").addClass("error");
          disableSubmitButton('applicant');
        } else if (!isEmailFormat($("#applicantParticipation #applicant_email_invoice").val().trim())) {
          $("#applicantParticipation #applicant_email_invoice").addClass("error");
          disableSubmitButton('applicant');
        } else if (!$("#em_agree2").prop("checked")) {
          $(".em_agree2").addClass("error");
          disableSubmitButton('applicant');
        } else {
          $("#applicantParticipation label.css-label, #applicantParticipation #email_input, #applicantParticipation input").removeClass("error");

          //Ajax zahtevek
          sendForm('applicant');
        }
        break;
      default: console.log('unknown tab type: '+ selectedTab);
    }

    function disableSubmitButton(typeClass, setValue) {
        const btnClass = 'button.btn.' + typeClass;
        $('#sub-form-websi #form '+ btnClass).prop('disabled', setValue || false);
    }


    function sendForm(type) {
        //var formData = new FormData($('#sub-form-websi form#form')[0]);

        var formData = new FormData();
        var form = $('#sub-form-websi form#form'); // <- change this depending on your scope/usecase

        formData.append('type', type);
        form.find('input[name][type!="file"], select[name], textarea[name]').each(function (i, e) {
            if ($(e).attr('type') == 'checkbox' || $(e).attr('type') == 'radio') {
                if ($(e).is(':checked')) {
                    formData.append($(e).attr('name'), $(e).val());
                }
            } else {
                formData.append($(e).attr('name'), $(e).val());
            }
        });

        form.find('input[name][type="file"]').each(function (i, e) {
            if ($(e)[0].files.length > 0) {
                formData.append($(e).attr('name'), $(e)[0].files[0]);
            }
        });

        $.ajax({
            type: "POST",
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            url: $('#sub-form-websi form#form').data('url'),
            data: formData,

            success: function (data) {
                if (data == 'OK') {
                    $('.end-section').show();
                    $('.end-section').css('margin-top', '100px');
                    $('.registration').hide();
                    $('html,body').animate({
                        scrollTop: $('.end-section').offset().top - 250
                    }, 1000);

                } else {
                    alert('Prišlo je do napake, poskusite ponovno.');
                }
            }
        });
    }

    return true;
}


/**
 * demo3.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2017, Codrops
 * http://www.codrops.com
 */


class MorphingBG {
    constructor(el) {
        this.DOM = {};
        this.DOM.el = el;
        this.DOM.paths = Array.from(this.DOM.el.querySelectorAll('path'));
        this.animate();
    }

    animate() {
        this.DOM.paths.forEach((path) => {
            setTimeout(() => {
                anime({
                    targets: path,
                    duration: anime.random(3000, 5000),
                    easing: [0.5, 0, 0.5, 1],
                    d: path.getAttribute('pathdata:id'),
                    loop: true,
                    direction: 'alternate'
                });
            }, anime.random(0, 1000));
        });
    }
};
if ($(".front-new-vawes").length) {
    new MorphingBG(document.querySelector('svg.scene'));
}

// **************************************************

$( ".agencies-checkbox" ).click(function() {
  $('.agency__infos').slideToggle(500);
});

$( ".customers-checkbox" ).click(function() {
  $('.customer__infos').slideToggle(500);
});

// logic for checkboxes
$('#is_ready').change(function(){
  $(this).parent().find('.reason').remove();
  if (!$('#accept_1').is(':checked')) {
    if ($(this).is(':checked')) {
      $('.form-commands button').addClass('btn-change');
    } else {
      $('.form-commands button').removeClass('btn-change');
    }
  } else {
    $(this).prop('checked', false);
    $(this).parent().append('<div class="reason"><br><small>Za potrditev morate izklopiti zgornjo opcijo.</small></div>');
  }
});

$('#accept_1').change(function(){
  $(this).parent().find('.reason').remove();
  if ($('#is_ready').is(':checked')) {
    $(this).prop('checked', false);
    $(this).parent().append('<div class="reason"><br><small>Za potrditev morate izklopiti spodnjo opcijo.</small></div>');
  }
});

// **************************************************

$('.open-other-participants').click(function() {
    // $(this).next().slideToggle(300);
    let parentDiv = $(this).parent();
    let type = $(this).data('type');
    let title = $(this).data('title');

    let idx = parentDiv.find('.other-participants').length;
    console.log(idx);

    let insertHtml =
    $(`<div class="other-participants">
        <h3>${title}</h3>
        <div class="form-group">
            <label>Ime in priimek</label>
            <input class="form-control" type="text" name="project_data[${type}][${idx}][name]" data-key="name">
        </div>
        <div class="form-group">
            <label>Funkcija</label>
            <input class="form-control" type="text" name="project_data[${type}][${idx}][function]" data-key="function">
        </div>
        <div class="form-group">
            <label>Podjetje</label>
            <input class="form-control" type="text" name="project_data[${type}][${idx}][company]" data-key="company">
        </div>
        <div class="extra-agency__btn">
            <a class="button : new-btn : blue : remove-person">odstrani osebo</a>
        </div>
    </div>`);

    parentDiv.append(insertHtml);
    removePerson();
    $('body, html').animate({ scrollTop: insertHtml.offset().top-200 }, 500);
});

removePerson();

function removePerson() {
    $('.remove-person').click(function() {
        // reindex
        let parent = $(this).closest('.other-participants__wrapper');
        $(this).parent().parent().remove();
        let participants = parent.find('.other-participants');
        let type = parent.children(':first').data('type');

        participants.each(function (idx) {
            let inputs = $(this).find('input');
            inputs.each(function () {
                let key = $(this).data('key');
                let attrName = 'project_data['+type+']['+idx+']['+key+']';
                $(this).attr('name', attrName);
            });
        });
    });
}

